import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => {
  const { color = '#5D7B9F', width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m18 6.5-12 12M18 18.5 6 6.5"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgComponent;
